export const AppState = Object.freeze({
  HOME: "home",
  INITIALIZING: "initializing_game",
  HUMAN_TURN: "human_turn",
  ENGINE_THINKING: "engine_thinking",
  PROMOTION: "promotion_pending",
  GAME_OVER: "game_over",
  ERROR: "error",
});

const ALLOWED = {
  home: ["initializing_game", "error"],
  initializing_game: [
    "human_turn",
    "engine_thinking",
    "game_over",
    "error",
    "home",
  ],
  human_turn: [
    "promotion_pending",
    "engine_thinking",
    "game_over",
    "home",
    "error",
    "human_turn",
  ],
  engine_thinking: [
    "human_turn",
    "game_over",
    "home",
    "error",
    "engine_thinking",
  ],
  promotion_pending: ["human_turn", "engine_thinking", "game_over", "home"],
  game_over: ["initializing_game", "home", "human_turn"],
  error: ["home", "human_turn", "initializing_game"],
};

export class StateMachine extends EventTarget {
  /** @type {string} */
  #state = AppState.HOME;
  get value() {
    return this.#state;
  }
  transition(next, detail = {}) {
    if (!ALLOWED[this.#state]?.includes(next)) {
      throw new Error(`Invalid state transition: ${this.#state} → ${next}`);
    }
    const previous = this.#state;
    this.#state = next;
    this.dispatchEvent(
      new CustomEvent("change", { detail: { previous, next, ...detail } }),
    );
  }
}
